import React from 'react';
import styles from './styles.module.scss';

export interface FinancialReceivablesData {
    outstandingOrder: number;
    piutangJatuhTempo: number;
    tagihanVendor7Hari: number;
}

interface IFinancialReceivablesWidgetProps {
    data?: FinancialReceivablesData;
}

const defaultData: FinancialReceivablesData = {
    outstandingOrder: 15390000,
    piutangJatuhTempo: 15390000,
    tagihanVendor7Hari: 29323998,
};

const formatRupiah = (val: number): string => {
    return 'Rp ' + val.toLocaleString('id-ID');
};

const FinancialReceivablesWidget: React.FC<IFinancialReceivablesWidgetProps> = ({
    data = defaultData,
}) => {
    return (
        <div className={styles.container}>
            <h2 className={styles.widgetTitle}>Piutang dan kewajiban</h2>

            <div className={styles.rowsList}>
                <div className={styles.rowItem}>
                    <span className={styles.rowLabel}>Outstanding order</span>
                    <span className={`${styles.rowValue} ${styles.goldValue}`}>
                        {formatRupiah(data.outstandingOrder)}
                    </span>
                </div>

                <div className={styles.rowItem}>
                    <span className={styles.rowLabel}>Piutang jatuh tempo</span>
                    <span className={`${styles.rowValue} ${styles.redValue}`}>
                        {formatRupiah(data.piutangJatuhTempo)}
                    </span>
                </div>

                <div className={styles.rowItem}>
                    <span className={styles.rowLabel}>Tagihan vendor &le; 7 hari</span>
                    <span className={`${styles.rowValue} ${styles.redValue}`}>
                        {formatRupiah(data.tagihanVendor7Hari)}
                    </span>
                </div>
            </div>

            <p className={styles.footerCaption}>
                Aging dihitung dari jatuh tempo order/invoice yang tersedia.
            </p>
        </div>
    );
};

export default FinancialReceivablesWidget;
